import { render, staticRenderFns } from "./AddNewUserAssureur.vue?vue&type=template&id=f2038ae0&"
import script from "./AddNewUserAssureur.vue?vue&type=script&lang=js&"
export * from "./AddNewUserAssureur.vue?vue&type=script&lang=js&"
import style0 from "./AddNewUserAssureur.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports